module.exports = __webpack_public_path__ + "static/media/flute.88960a89.svg";